import { render, staticRenderFns } from "./ComplaintDetails.vue?vue&type=template&id=eb41bbba&scoped=true"
import script from "./ComplaintDetails.vue?vue&type=script&lang=js"
export * from "./ComplaintDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetails.vue?vue&type=style&index=0&id=eb41bbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb41bbba",
  null
  
)

export default component.exports